import { ColDef, type ICellRendererParams } from "ag-grid-community";
import { Typography } from "@mui/material";
import { ElbTargetsCellRenderer } from "./elb-targets-cell-renderer/ElbTargetsCellRenderer";
import { jiraIssuesColumnDef } from "../../common/jiraIssuesColumnDef";
import { tagsColumnDef } from "../../common/tagsColumnDef";
import { smartTagsColumnDef } from "../../common/smartTagsColumnDef";
import { regionColumnDef } from "../../common/regionColumnDef";
import { forecastedEOMColumnDef } from "../../common/forecastedEOMColumnDef";
import { resourceAccountColumnDef } from "../../common/resourceAccountColumnDef";
import { resourceTotalSpendColumnDef } from "../../common/resourceTotalSpendColumnDef";
import { resourceCreatedByColumnDef } from "../../common/resourceCreatedByColumnDef";
import { getResourceCreationTimeColumnDef } from "../../common/getResourceCreationTimeColumnDef";
import { FilteredElbResourceItem } from "@/services/cloudchipr.api";
import { getResourceIdentifierColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceIdentifierColumnDef";
import { getResourceMetricsColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/getResourceMetricsColumnDef";
import { taskColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/taskColumnDef";
import { billingCostColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/billingCostColumnDef";
import { getListingPriceColumnDef } from "@/components/pages/common/resources-ag-grid/components/column-defs/common/listingPriceColumnDef";

export const elbColumnDefs: ColDef[] = [
  getResourceIdentifierColumnDef("Load Balancer", "load_balancer_name"),

  forecastedEOMColumnDef,
  billingCostColumnDef,
  getListingPriceColumnDef("elb"),

  resourceAccountColumnDef,

  resourceTotalSpendColumnDef,

  resourceCreatedByColumnDef,

  getResourceCreationTimeColumnDef("Creation Time"),

  getResourceMetricsColumnDef("Traffic Sum", "processed_bytes", "elb"),

  { field: "resource.dns_name", headerName: "DNS Name" },

  {
    field: "resource.targets",
    headerName: "Targets",
    cellRenderer: ElbTargetsCellRenderer,
    valueGetter: ({ data }) => {
      const targets = data?.resource?.targets;

      if (!targets?.length) {
        return "No Targets";
      }

      return targets.join(", ");
    },
  },

  { field: "resource.type", headerName: "Type" },

  {
    field: "resource.scheme",
    headerName: "Scheme",
    cellRenderer: ({ data }: ICellRendererParams<FilteredElbResourceItem>) => {
      const scheme = data?.resource?.scheme;

      if (!scheme) {
        return "-";
      }

      const labels: Record<string, string> = {
        internal: "Internal",
        internet_facing: "Internet-facing",
      };

      return (
        <Typography variant="body2">
          {labels?.[scheme] ?? scheme ?? "-"}
        </Typography>
      );
    },
  },

  regionColumnDef,
  tagsColumnDef,
  smartTagsColumnDef,
  taskColumnDef,
  jiraIssuesColumnDef,
];
